// extracted by mini-css-extract-plugin
module.exports = {"numberText":"NotificationWidget_numberText__YrgcF"};